import { render, staticRenderFns } from "./BannerModulos.vue?vue&type=template&id=140a34f7&scoped=true&"
import script from "./BannerModulos.vue?vue&type=script&lang=js&"
export * from "./BannerModulos.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=140a34f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a34f7",
  null
  
)

export default component.exports